import React, { useState, useEffect } from "react";
import preloader from "../../assets/preloader1.gif"

const RESPONSE_OPTIONS = [
  { value: "yes",     label: "Yes",     color: "#22c55e" },
  { value: "no",      label: "No",      color: "#ef4444" },
  { value: "partial", label: "Partial", color: "#f59e0b" },
];

const TABLE_HEADERS = ["Questionnaires", "Description", "Sub Dimension", "Response", "Comment"];

const ReadOnlyRow = ({ item, answer }) => (
  <tr
    style={{ borderBottom: "1px solid #f0f0f0" }}
    onMouseEnter={e => e.currentTarget.style.background = "#fafafe"}
    onMouseLeave={e => e.currentTarget.style.background = "white"}
  >
    <td style={{ padding: "13px 12px", maxWidth: "240px", color: "#222", lineHeight: 1.5 }}>
      {item.question}
    </td>

    <td style={{ padding: "13px 12px", maxWidth: "220px", color: "#555", lineHeight: 1.5 }}>
      {item.description}
    </td>

    <td style={{ padding: "13px 12px", color: "#555", whiteSpace: "nowrap" }}>
      {item.subDimension}
    </td>

    <td style={{ padding: "13px 12px", whiteSpace: "nowrap" }}>
      {RESPONSE_OPTIONS.map((opt) => {
        const isSelected = answer?.response === opt.value;
        return (
          <label
            key={opt.value}
            style={{
              marginRight: "14px",
              cursor: "default",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "13px",
              color: isSelected ? opt.color : "#555",
              fontWeight: isSelected ? "700" : "400",
            }}
          >
            <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
              {/* Radio circle */}
              <span style={{
                display: "inline-block",
                width: "14px", height: "14px",
                borderRadius: "50%",
                border: `2px solid ${isSelected ? opt.color : "#888"}`,
                background: "white",
              }} />
              {/* Dot if selected */}
              {isSelected && (
                <span style={{
                  position: "absolute",
                  width: "6px", height: "6px",
                  borderRadius: "50%",
                  background: opt.color,
                  top: "50%", left: "50%",
                  transform: "translate(-50%, -50%)",
                }} />
              )}
            </span>
            {opt.label}
          </label>
        );
      })}
    </td>

    {/* Comment — read only textarea */}
    <td style={{ padding: "13px 12px" }}>
      <textarea
        value={answer?.comment || ""}
        readOnly
        placeholder="No comment"
        style={{
          width: "180px",
          minHeight: "48px",
          resize: "vertical",
          border: "1px solid #ddd",
          borderRadius: "4px",
          padding: "5px 7px",
          fontSize: "12px",
          outline: "none",
          fontFamily: "inherit",
          background: "#fafafa",
          color: "#555",
          cursor: "default",
        }}
      />
    </td>
  </tr>
);

const ViewModal = ({ record, onClose }) => {
  const [currentSectionIdx, setCurrentSectionIdx] = useState(0);
  const [sections, setSections] = useState([]);
  const [answers,  setAnswers]  = useState({});
  const [loading,  setLoading]  = useState(true);
  const [toolMeta, setToolMeta] = useState({ tool: "", tool_type: "" });

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const res  = await fetch(`${process.env.REACT_APP_API_URL}/form/${record.id}`);
        const data = await res.json();
        const raw  = (data.structure?.sections || []).sort((a, b) => a.order - b.order);

        setToolMeta({ tool: data.structure?.tool || "", tool_type: data.structure?.tool_type || "" });
        setSections(raw);
        setAnswers(
          Object.fromEntries(
            raw.map((sec) => [
              sec.section,
              sec.questions.map((q) => ({
                id:       q.id,
                response: q.response || null,
                comment:  q.comment  || "",
              })),
            ])
          )
        );
      } catch (err) {
        console.error("Failed to load form for view:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchForm();
  }, [record.id]);

  const sectionNames    = sections.map(s => s.section);
  const currentSection  = sections[currentSectionIdx];
  const sectionAnswers  = answers[currentSection?.section] || [];

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onClose}
    >
      <div
        style={{ background: "white", borderRadius: "12px", width: "min(1100px, 96vw)", height: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,0.2)", fontFamily: "'Segoe UI', Arial, sans-serif", overflow: "hidden" }}
        onClick={e => e.stopPropagation()}
      >

        {/* ── SubHeader — same style as AssessmentSubHeader ── */}
        <div style={{ background: "white", borderBottom: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 20px", flexWrap: "wrap", gap: "10px" }}>
        

          <div style={{ display: "flex", alignItems: "center", gap: "18px", flexWrap: "wrap" }}>
            {/* read-only badge */}
            

            <div style={{ border: "1px solid #ddd", borderRadius: "6px", padding: "7px 16px", fontSize: "13px", background: "#fafafa" }}>
              Selected Type:{" "}
              <span style={{ color: "#bb1ccc", fontWeight: "700" }}>{toolMeta.tool_type}</span>
              &nbsp;&nbsp; Tool Name:{" "}
              <span style={{ color: "#bb1ccc", fontWeight: "700" }}>{toolMeta.tool}</span>
            </div>
          </div>

          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#999" }}>✕</button>
        </div>

      
{loading && (
  <div
    style={{
      flex: 1,                     // take full modal body height
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",    // CENTER vertically
      gap: "10px",
    }}
  >
    <img src={preloader} width={200} alt="Loading" />
    <p style={{ textAlign: "center", color: "#999" }}>
      Loading form data...
    </p>
  </div>
)}

        {!loading && (
          <>
            <div style={{ padding: "16px 2px 4px", margin: "0 auto", width: "95%", display: "flex", alignItems: "flex-start" }}>
              {sectionNames.map((section, i) => {
                const isActive = i === currentSectionIdx;
                const isPast   = i < currentSectionIdx;
                return (
                  <div
                    key={section}
                    style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "1", minWidth: "72px", cursor: "pointer" }}
                    onClick={() => setCurrentSectionIdx(i)}
                    title={section}
                  >
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                      <div style={{ flex: 1, height: "2px", background: i === 0 ? "transparent" : isPast ? "#bb1ccc" : "#ddd" }} />
                      <div style={{
                        width: "32px", height: "32px", borderRadius: "50%",
                        background: "#bb1ccc", color: "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: "13px", fontWeight: "bold", flexShrink: 0,
                        opacity: !isActive && !isPast ? 0.4 : 1,
                      }}>
                        {isPast ? "✔" : i + 1}
                      </div>
                      <div style={{ flex: 1, height: "2px", background: i === sectionNames.length - 1 ? "transparent" : isPast ? "#bb1ccc" : "#ddd" }} />
                    </div>
                    <div style={{ fontSize: "9px", color: isActive ? "#bb1ccc" : "#555", textAlign: "center", marginTop: "5px", lineHeight: 1.3, fontWeight: isActive ? "700" : "400" }}>
                      {section}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* ── QuestionTable — same layout as QuestionTable.jsx ── */}
            <div style={{ flex: 1, overflowY: "auto", padding: "8px 20px 20px" }}>
              <table style={{ width: "90%", margin: "0 auto", borderCollapse: "collapse", fontSize: "13px" }}>
                <thead>
                  <tr style={{ borderBottom: "2px solid #ddd" }}>
                    {TABLE_HEADERS.map(h => (
                      <th key={h} style={{ textAlign: "left", padding: "10px 12px", fontWeight: "700", color: "#222", background: "white", whiteSpace: "nowrap" }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {currentSection?.questions.map((q, qi) => (
                    <ReadOnlyRow
                      key={q.id || qi}
                      item={q}
                      answer={sectionAnswers[qi]}
                    />
                  ))}
                </tbody>
              </table>
            </div>

            {/* ── Footer — same style as AssessmentFooter ── */}
            <div style={{ borderTop: "1px solid #eee", padding: "12px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "0 -2px 8px rgba(0,0,0,0.06)" }}>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={() => setCurrentSectionIdx(i => Math.max(0, i - 1))}
                  disabled={currentSectionIdx === 0}
                  style={{ background: currentSectionIdx === 0 ? "#9ca3af" : "#bb1ccc", color: "white", border: "none", borderRadius: "6px", padding: "10px 28px", cursor: currentSectionIdx === 0 ? "not-allowed" : "pointer", fontWeight: "700", fontSize: "14px" }}
                >
                  PREV
                </button>
                <button
                  onClick={() => setCurrentSectionIdx(i => Math.min(sections.length - 1, i + 1))}
                  disabled={currentSectionIdx === sections.length - 1}
                  style={{ background: currentSectionIdx === sections.length - 1 ? "#9ca3af" : "#bb1ccc", color: "white", border: "none", borderRadius: "6px", padding: "10px 28px", cursor: currentSectionIdx === sections.length - 1 ? "not-allowed" : "pointer", fontWeight: "700", fontSize: "14px" }}
                >
                  NEXT
                </button>
              </div>
              <button
                onClick={onClose}
                style={{ background: "#bb1ccc", color: "white", border: "none", borderRadius: "6px", padding: "10px 28px", cursor: "pointer", fontWeight: "700", fontSize: "14px" }}
              >
                CLOSE
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ViewModal;